import { generatePath } from "react-router-dom";

import { RoutePath } from "./routePath";

/**
 * Path constants for journey flows.
 * `flow()` builds a path for any slug; `flows.*` provides constants for known slugs.
 */
export const RouteTemplates = {
  flow: "/flow/:slug",
} as const;

export const flowPaths = {
  flow: RoutePath(RouteTemplates.flow),
  flows: {
    termLifeExtension: generatePath(RouteTemplates.flow, { slug: "term-life-extension" }),
    application: generatePath(RouteTemplates.flow, { slug: "application" }),
    coverageAdjustment: generatePath(RouteTemplates.flow, { slug: "coverage-adjustment" }),
    coverageCollection: generatePath(RouteTemplates.flow, { slug: "coverage-collection" }),
    ineligibilityWarning: generatePath(RouteTemplates.flow, { slug: "ineligibility-warning" }),
  },
};
